// Import this explicitly so the test and production module graphs match.
import { OrderedRecord } from "../types/redux-store";

type EntityState<T> = OrderedRecord<T>;
type RootEntitiesState = {
  entities: Record<string, EntityState<unknown>> & {
    inboxes?: Record<string, EntityState<unknown>>;
  };
};

export const getOrderedEntities = <T>(entities: OrderedRecord<T>) => {
  return [...new Set(entities.allIds)]
    .map((id) => entities.byId[id])
    .filter((x): x is T => x !== undefined);
};

export const getEntityMap = <T>(
  entities: string[],
  entityIds: Record<string, T>,
  specificIds: string[] | null = null
): T[] => {
  const entityMap: T[] = [];
  if (!entities) {
    return [];
  }
  entities.forEach((id) => {
    if (
      specificIds === null ||
      (specificIds !== null && specificIds.includes(id))
    ) {
      entityMap.push(entityIds[id]);
    }
  });
  return entityMap;
};

export const getEntities = <T>(
  state: RootEntitiesState,
  entity: string,
  specificIds: string[] | null = null
): T[] => {
  const entities: T[] = [];
  const stateEntities = state.entities[entity] as EntityState<T> | undefined;
  if (!stateEntities || !stateEntities.allIds) {
    return [];
  }
  stateEntities.allIds.forEach((id) => {
    const entityItem = stateEntities.byId[id];
    if (
      entityItem &&
      (specificIds === null ||
        (specificIds !== null && specificIds.includes(id)))
    ) {
      entities.push(entityItem);
    }
  });
  return entities;
};

export const getEntitiesByPage = <T>(
  state: { entities: Record<string, Record<string, EntityState<T>>> },
  entity: string,
  page: string,
  specificIds: string[] | null = null
): T[] => {
  const entities: T[] = [];
  const stateEntities = state.entities[entity]?.[page];
  if (!stateEntities) {
    return [];
  }
  stateEntities.allIds.forEach((id) => {
    const entityItem = stateEntities.byId[id];
    if (
      entityItem &&
      (specificIds === null ||
        (specificIds !== null && specificIds.includes(id)))
    ) {
      entities.push(entityItem);
    }
  });
  return entities;
};
export const getGenericEntities = <T>(
  _state: unknown,
  stateEntities: EntityState<T> | null | undefined,
  specificIds: string[] | null = null
): T[] => {
  const entities: T[] = [];
  if (!stateEntities) {
    return [];
  }
  stateEntities.allIds.forEach((id) => {
    const entityItem = stateEntities.byId[id];
    if (
      entityItem &&
      (specificIds === null ||
        (specificIds !== null && specificIds.includes(id)))
    ) {
      entities.push(entityItem);
    }
  });
  return entities;
};
export const getInboxEntities = <T>(
  state: RootEntitiesState,
  entity: string,
  specificIds: string[] | null = null
): T[] => {
  const entities: T[] = [];
  const stateEntities = state.entities.inboxes?.[entity] as
    EntityState<T> | undefined;
  if (!stateEntities) {
    return [];
  }
  stateEntities.allIds.forEach((id) => {
    const entityItem = stateEntities.byId[id];
    if (
      entityItem &&
      (specificIds === null ||
        (specificIds !== null && specificIds.includes(id)))
    ) {
      entities.push(entityItem);
    }
  });
  return entities;
};
